import * as React from 'react';
import { Dispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Action } from 'redux';

import { ToastComponent, ToastType, ToastOptions } from '@common/components';
import { CustomerViewModel } from '@models/Customer';
import { customerService } from '@services/CustomerService';

import { CustomerPickerState } from './customer-picker.reducer';

// We can use enums instead of type constants like in the example. This is a newer TS feature
export enum CustomerPickerActionType {
  ClearCustomer = 'ClearCustomer',
  GetCustomerFailure = 'GetCustomerFailure',
  GetCustomerStart = 'GetCustomerStart',
  GetCustomerSuccess = 'GetCustomerSuccess'
}

// This is defining the action definition for certain actions on the page.
// There may be multiple types of these on a given page.
// All properties should be readonly.
interface CustomerPickerAction extends Action {
  readonly type: CustomerPickerActionType;
}

export interface ClearCustomerAction extends CustomerPickerAction {
  readonly customerEmitter: (customer?: CustomerViewModel) => void;
}

export interface GetCustomerFailureAction extends CustomerPickerAction {}
export interface GetCustomerStartAction extends CustomerPickerAction {}
export interface GetCustomerSuccessAction extends CustomerPickerAction {
  readonly customer: CustomerViewModel;
  readonly customerEmitter: (customer?: CustomerViewModel) => void;
}

// Actions for each action type declared here.
// They should all return an action object.
export function clearCustomer(customerEmitter: (customer?: CustomerViewModel) => void): ClearCustomerAction {
  return {
    type: CustomerPickerActionType.ClearCustomer,
    customerEmitter: customerEmitter
  };
}

export const getCustomer = (id: number, customerEmitter: (customer?: CustomerViewModel) => void) => {
  return async (dispatch: Dispatch<CustomerPickerState>) => {
    dispatch(getCustomerStart());
    try {
      const customer: CustomerViewModel = await customerService.getCustomer(id);
      dispatch(getCustomerSuccess(customer, customerEmitter));
    } catch (e) {
      dispatch(getCustomerFailure());
    }
  };
};

function getCustomerFailure(): GetCustomerFailureAction {
  toast.error(
    <ToastComponent type={ToastType.Error} message="Failed fetching customer from network" />,
    ToastOptions.Error
  );
  return {
    type: CustomerPickerActionType.GetCustomerFailure
  };
}

function getCustomerStart(): GetCustomerStartAction {
  return {
    type: CustomerPickerActionType.GetCustomerStart
  };
}

function getCustomerSuccess(
  customer: CustomerViewModel,
  customerEmitter: (customer: CustomerViewModel) => void
): GetCustomerSuccessAction {
  return {
    type: CustomerPickerActionType.GetCustomerSuccess,
    customer: customer,
    customerEmitter: customerEmitter
  };
}

export function lookupCustomer(value: string, id: number) {
  return customerService.searchCustomers(value, id);
}



// WEBPACK FOOTER //
// ./src/customer/_components/customer-picker/customer-picker.actions.tsx